import RevenueByBrand from "./components/RevenueByBrand";

export default function RevenueMonitor() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <main className="text-sm text-gray-500">
        <RevenueByBrand />
      </main>
    </div>
  );
}